import type { RadioButtonGroupProps } from '@hover/blueprint';
import { RadioButton, RadioButtonGroup } from '@hover/blueprint';
import React from 'react';

import { buttonPressed } from 'src/shared/telemetry';

import { useHomeownerAppContext } from '../../hooks';
import { formatSpaceType } from '../Utils';

const spaceTypes = [
  'exterior',
  'bedroom',
  'bathroom',
  'dining_room',
  'home_office',
  'kitchen',
  'living_room',
];

export interface SpaceTypeSelectorProps
  extends Omit<RadioButtonGroupProps, 'children'> {
  spaceType: string;
  setSpaceType: (type: string) => void;
}

const SpaceTypeSelector = ({
  spaceType,
  setSpaceType,
  onChange,
  ...props
}: SpaceTypeSelectorProps) => {
  const { trackingData } = useHomeownerAppContext();

  return (
    <RadioButtonGroup
      display="flex"
      flexDirection="row"
      flexWrap="wrap"
      gap={200}
      onChange={type => {
        buttonPressed({
          ...trackingData,
          track_id: 'upload-image-space-type-selection',
          button_location: 'middle-main-page',
          button_text: type,
        });

        setSpaceType(type);
        onChange?.(type);
      }}
      value={spaceType}
      {...props}
    >
      {spaceTypes.map(type => (
        <RadioButton
          key={type}
          size={{ base: 'small', tablet: 'medium' }}
          value={type}
        >
          {formatSpaceType(type)}
        </RadioButton>
      ))}
    </RadioButtonGroup>
  );
};

export { SpaceTypeSelector };
